import React from "react";
import SiteHeader from "../components/SiteHeader.jsx";
import SiteFooter from "../components/SiteFooter.jsx";
import { AlertTriangle } from "lucide-react";

export default function MedicalDisclaimer() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SiteHeader />
      <main className="max-w-3xl mx-auto px-6 py-14 flex-1" data-testid="medical-disclaimer-page">
        <div className="text-xs tracking-widest uppercase text-rose-700 font-semibold">Important</div>
        <h1 className="font-heading text-4xl font-extrabold text-[#111827] mt-2">Medical Disclaimer</h1>

        <div className="mt-8 p-5 rounded-lg bg-amber-50 border border-amber-200 flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-amber-700 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-amber-900">
            <strong>This tool is for reference only and requires a qualified medical practitioner to approve any treatments. It is intended for educational and clinical reference purposes only.</strong>
            <div className="mt-2">
              <strong>RapidCare SA is NOT a medical device</strong> and is not registered with the South African Health Products Regulatory Authority (SAHPRA). It performs no autonomous diagnosis, prescribing, monitoring or interpretation of patient-specific data. See <a href="/about#sahpra-section" className="underline">About → SAHPRA &amp; regulatory status</a> for the full position.
            </div>
          </div>
        </div>

        <div className="prose prose-slate max-w-none mt-8 text-slate-700 leading-relaxed space-y-6">
          <p>
            RapidCare SA does not diagnose patients, replace clinical judgement, or substitute for professional medical advice, supervision, or specialist consultation. Every recommendation, dose, calculation, protocol step, or code returned by the platform is reference content only and must be reviewed, interpreted, and approved by a qualified medical practitioner before being applied to a patient.
          </p>

          <p>
            All clinical information should be verified against current South African Standard Treatment Guidelines (STG/EML), the South African Medicines Formulary (SAMF), and relevant specialty society recommendations before application in patient care.
          </p>

          <p>
            The developers of RapidCare SA accept no liability for clinical decisions made based on information provided by this platform. Users are solely responsible for the interpretation and application of any content in their clinical practice.
          </p>

          <p>
            In an emergency, contact your nearest emergency medical services immediately.
          </p>

          <p>
            RapidCare SA is not a substitute for the clinical responsibility of the registered healthcare professional using it. The platform does not provide autonomous medical decisions, prescriptions, or diagnoses.
          </p>

          <section className="border-t border-slate-200 pt-4 text-xs text-slate-500">
            By signing up or continuing to use RapidCare SA, you acknowledge that you have read and understood this disclaimer and agree to use the platform accordingly. Questions or clinical feedback: <a href="mailto:rapidcaresasupport@gmail.com" className="text-[#111827] underline">rapidcaresasupport@gmail.com</a>.
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
